import Service 			from "./../../Libs/Service";

import { Version } 		from "./Version";
import { Elements }		from "./Elements";

let Animation = new Service({

	Name: "Animation",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},
		"Animation Added": function(animation) {

			if (animation["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationAdded: animation
				}]);

			}

		},
		"Animation Step Added": function(animationStep) {

			if (animationStep["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationStepAdded: animationStep
				}]);

			}

		},
		"Animation Changed": function(animation) {

			if (animation["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationChanged: animation
				}]);

			}

		},
		"Animation Step Changed": function(animationStep) {

			if (animationStep["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationStepChanged: animationStep
				}]);

			}

		},
		"Animation Removed": function(animation) {

			if (animation["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationRemoved: animation
				}]);

			}

		},
		"Animation Step Removed": function(animationStep) {

			if (animationStep["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					AnimationStepRemoved: animationStep
				}]);

			}

		},
		"IFrame Data:StartAnimationPlaying": function(animationId) {

			this.animationPlaying[animationId] = true;

			let animation = AnimationService.AnimationsById[animationId];
			if (animation?.["version_id"] === Version.SelectedVersion.id && animation?.["element_codename"] === Elements.SelectedElement?.codename) {

				Broadcast.call("Selected Element Animation Playing Changed");

			}

		},
		"IFrame Data:StopAnimationPlaying": function(animationId) {

			this.animationPlaying[animationId] = false;

			let animation = AnimationService.AnimationsById[animationId];
			if (animation?.["version_id"] === Version.SelectedVersion.id && animation?.["element_codename"] === Elements.SelectedElement?.codename) {

				Broadcast.call("Selected Element Animation Playing Changed");

			}

		},
		"Refresh Iframe": function() {

			if (_.size(this.animationPlaying) > 0) {

				this.animationPlaying = {};

				Broadcast.call("Selected Element Animation Playing Changed");

			}

		}
	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Animations": function(animations, data, size, serverId) {

			this.setAnimations(animations, !data.AnimationsCreativeId && !data.AnimationsVersionId, serverId);

			// Первоначальная загрузка анимаций всех версий креатива
			if (data.AnimationsCreativeId) Broadcast.call("Creative Animations Loaded", [data.AnimationsCreativeId]);
			if (data.AnimationsVersionId) Broadcast.call("Version Animations Loaded", [data.AnimationsVersionId]);

		},

		"Animation": function(animation, data, size, serverId) {

			this.setAnimation(animation, data.AnimationId, true, serverId);

		},

		"AnimationSteps": function(animationSteps, data, size, serverId) {

			_.each(animationSteps, (animationStep, animationStepId) => {

				this.setAnimationStep(animationStep, parseInt(animationStepId), !data.AnimationStepsCreativeId && !data.AnimationStepsVersionId, serverId);

			});

			// Первоначальная загрузка анимаций всех версий креатива
			if (data.AnimationStepsCreativeId) Broadcast.call("Creative Animation Steps Loaded", [data.AnimationStepsCreativeId]);
			if (data.AnimationStepsVersionId) Broadcast.call("Version Animation Steps Loaded", [data.AnimationStepsVersionId]);

		},

		"AnimationStep": function(animationStep, data, size, serverId) {

			this.setAnimationStep(animationStep, data.AnimationStepId, true, serverId);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и анимаций
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.AnimationsByIdByServer = {};
		this.AnimationsByHierarchyByServer = {};
		this.AnimationStepsByIdByServer = {};
		this.AnimationStepsByHierarchyByServer = {};

		this.animationPlaying = {}; // Будем помечать тут статус проигрывания анимации который сообщается из iframe

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (AnimationsById[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.AnimationsById = this.getServerMap(this.AnimationsByIdByServer, serverId);
		this.AnimationsByHierarchy = this.getServerMap(this.AnimationsByHierarchyByServer, serverId);
		this.AnimationStepsById = this.getServerMap(this.AnimationStepsByIdByServer, serverId);
		this.AnimationStepsByHierarchy = this.getServerMap(this.AnimationStepsByHierarchyByServer, serverId);

	},

	setAnimations(animations, isBroadcast = true, serverId) {

		_.each(animations, animation => {

			this.setAnimation(animation, animation.id, isBroadcast, serverId);

		});

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setAnimation(animation, animationId = null, isBroadcast = true, serverId) {

		serverId = serverId || this.NodeServerId;

		let animationsById = this.getServerMap(this.AnimationsByIdByServer, serverId),
			animationsByHierarchy = this.getServerMap(this.AnimationsByHierarchyByServer, serverId);

		let oldAnimation = animationsById[animationId];

		if (animation) {

			animationsById[animation.id] = animation;

			if (!animationsByHierarchy[animation["version_id"]]) animationsByHierarchy[animation["version_id"]] = {};
			if (!animationsByHierarchy[animation["version_id"]][animation["screen_codename"]]) animationsByHierarchy[animation["version_id"]][animation["screen_codename"]] = {};
			if (!animationsByHierarchy[animation["version_id"]][animation["screen_codename"]][animation["element_codename"]]) animationsByHierarchy[animation["version_id"]][animation["screen_codename"]][animation["element_codename"]] = {};

			animationsByHierarchy[animation["version_id"]][animation["screen_codename"]][animation["element_codename"]][animation.codename] = animation;

		} else if (oldAnimation) {

			delete animationsById[oldAnimation.id];
			delete animationsByHierarchy[oldAnimation["version_id"]][oldAnimation["screen_codename"]][oldAnimation["element_codename"]][oldAnimation.codename];

		}

		if (isBroadcast) {

			let eventPrefixes = ["Animation"];
			// TODO: не хватает глобального доступа к имени выделенного экрана, чтобы однозначно определить меняется ли анимация выделенного элемента
			if (oldAnimation?.["version_id"] === Version.SelectedVersion?.id && oldAnimation?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Animation"); // Это конечно не совсем точно - но примерно можно определить принадлежность к текущему элементу
			else if (animation?.["version_id"] === Version.SelectedVersion?.id && animation?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Animation");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldAnimation, animation, eventPrefixes);

		}

	},

	setAnimationStep(animationStep, animationStepId, isBroadcast = true, serverId) {

		serverId = serverId || this.NodeServerId;

		let animationStepsById = this.getServerMap(this.AnimationStepsByIdByServer, serverId),
			animationStepsByHierarchy = this.getServerMap(this.AnimationStepsByHierarchyByServer, serverId);

		let oldAnimationStep = animationStepsById[animationStepId];

		if (animationStep) {

			animationStepsById[animationStep.id] = animationStep;

			if (!animationStepsByHierarchy[animationStep["version_id"]]) animationStepsByHierarchy[animationStep["version_id"]] = {};
			if (!animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]]) animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]] = {};
			if (!animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]][animationStep["element_codename"]]) animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]][animationStep["element_codename"]] = {};
			if (!animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]][animationStep["element_codename"]][animationStep["animation_codename"]]) animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]][animationStep["element_codename"]][animationStep["animation_codename"]] = {};

			animationStepsByHierarchy[animationStep["version_id"]][animationStep["screen_codename"]][animationStep["element_codename"]][animationStep["animation_codename"]][animationStep.id] = animationStep;

		} else if (oldAnimationStep) {

			delete animationStepsById[oldAnimationStep.id];
			delete animationStepsByHierarchy[oldAnimationStep["version_id"]][oldAnimationStep["screen_codename"]][oldAnimationStep["element_codename"]][oldAnimationStep["animation_codename"]][oldAnimationStep.id];

		}

		if (isBroadcast) {

			let eventPrefixes = ["Animation Step"];
			// TODO: не хватает глобального доступа к имени выделенного экрана, чтобы однозначно определить меняется ли анимация выделенного элемента
			if (oldAnimationStep?.["version_id"] === Version.SelectedVersion?.id && oldAnimationStep?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Animation"); // Это конечно не совсем точно - но примерно можно определить принадлежность к текущему элементу
			else if (animationStep?.["version_id"] === Version.SelectedVersion?.id && animationStep?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Animation");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldAnimationStep, animationStep, eventPrefixes);

		}

	},

	getVersionAnimations(version) {

		return this.AnimationsByHierarchy[version.id];

	},

	getAnimations(versionId, screenCodename, elementCodename) {

		return _.orderBy(_.values(this.AnimationsByHierarchy[versionId]?.[screenCodename]?.[elementCodename]), 'id') || [];

	},

	getVersionAnimationSteps(version) {

		return this.AnimationStepsByHierarchy[version.id];

	}

});

window.AnimationService = Animation;

export { Animation }

